// ─── Liste de courses — un doc par espace ──────────────────────────
// Alimentée manuellement OU depuis une recette/un repas (mise à l'échelle,
// cf. services/courses.js). Pas de rayons/tri pour l'instant (référentiel
// séparé) — coche simple pour rayer au fur et à mesure des courses.
//   listeCourses/{espaceId} = { items: [{id, nom, quantite, unite, coche}], maj }
import { db } from '@mop/core';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';

function nouvelId() {
  return 'crs_' + Math.random().toString(36).slice(2, 9) + Date.now().toString(36);
}

export function ecouterListeCourses(espaceId, callback, onErreur) {
  if (!espaceId) { callback([]); return () => {}; }
  return onSnapshot(doc(db, 'listeCourses', espaceId),
    s => callback(s.exists() ? (s.data().items || []) : []),
    (e) => { callback([]); onErreur?.(e); });
}

export async function enregistrerListeCourses(espaceId, items) {
  if (!espaceId) return;
  await setDoc(doc(db, 'listeCourses', espaceId), { items: items || [], maj: new Date().toISOString() }, { merge: true });
}

// Fusionne des ingrédients (cf. services/courses.js) dans la liste actuelle :
// même nom+unité (insensible à la casse) ET quantités numériques → sommées ;
// sinon nouvelle ligne. Renvoie la nouvelle liste (pure, n'écrit rien).
export function fusionnerDansListe(itemsActuels, ingredients) {
  const out = (itemsActuels || []).map(i => ({ ...i }));
  for (const ing of (ingredients || [])) {
    const nom = (ing.nom || '').trim();
    if (!nom) continue;
    const unite = (ing.unite || '').trim();
    const qn = parseFloat(String(ing.quantite || '').replace(',', '.'));
    const cible = out.find(i => !i.coche && i.nom.toLowerCase() === nom.toLowerCase() && (i.unite || '').toLowerCase() === unite.toLowerCase());
    const cibleQn = cible ? parseFloat(String(cible.quantite || '').replace(',', '.')) : NaN;
    if (cible && !isNaN(qn) && !isNaN(cibleQn)) {
      cible.quantite = String(Math.round((cibleQn + qn) * 100) / 100);
    } else if (!cible) {
      out.push({ id: nouvelId(), nom, unite, quantite: ing.quantite || '', coche: false });
    }
  }
  return out;
}

export function basculerCoche(items, id) {
  return (items || []).map(i => i.id === id ? { ...i, coche: !i.coche } : i);
}
export function retirerItem(items, id) {
  return (items || []).filter(i => i.id !== id);
}
export function viderCoches(items) {
  return (items || []).filter(i => !i.coche);
}
